import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Table({ className, children, reflow, ...rest }) {
    return (_jsx("div", { className: "fwfa-table-wrap", "data-table": reflow ? "reflow" : undefined, children: _jsx("table", { className: cn("fwfa-table", className), ...rest, children: children }) }));
}
//# sourceMappingURL=Table.js.map